import { render, staticRenderFns } from "./NewSystem.vue?vue&type=template&id=3486691d&scoped=true&"
import script from "./NewSystem.vue?vue&type=script&lang=js&"
export * from "./NewSystem.vue?vue&type=script&lang=js&"
import style0 from "./NewSystem.vue?vue&type=style&index=0&id=3486691d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3486691d",
  null
  
)

export default component.exports